/**
 * Testimonial Card Component
 *
 * Individual testimonial card for displaying customer reviews
 * with star rating, quote, and customer information.
 */

import { Card } from '../Card';
import type { Testimonial } from '../../types/testimonial';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  // Render star rating (similar to LessonCard pattern)
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={i < rating ? 'text-yellow-400' : 'text-gray-300'}>
        ★
      </span>
    ));
  };

  return (
    <Card variant="brutalist" className="h-full flex flex-col">
      {/* Star Rating */}
      <div className="flex mb-4 text-xl">
        {renderStars(testimonial.rating)}
      </div>

      {/* Quote */}
      <blockquote className="font-body text-gray-700 mb-6 leading-relaxed flex-1">
        "{testimonial.quote}"
      </blockquote>

      {/* Attribution */}
      <div className="mt-auto pt-4 border-t-4 border-gray-200">
        <p className="font-mono font-bold uppercase tracking-wide text-gray-900">{testimonial.name}</p>
        <p className="font-body text-sm text-gray-600 mt-1">
          {testimonial.location}
        </p>
        <p className="font-mono text-xs uppercase tracking-wide text-amaranth_purple-500 mt-2">
          {testimonial.courseTaken}
        </p>
      </div>
    </Card>
  );
};
